export const searchTypes = ['documentNumber', 'name', 'id']
export const documentByTypeAndCountry = {
  kyb: {
    BR: ['CNPJ'],
    CO: ['NIT'],
    AR: ['CUIT'],
  },
  kyc: {
    BR: ['CPF'],
    CO: ['CC', 'CE'],
    AR: ['CUIL'],
  },
}

export const DocumentValidation = {
  kyb: {
    BR: /^([0-9]){14}$/,
    CO: /^([0-9]){8,15}$/,
    AR: /^(30|33)[0-9]{8}[0-9]$/,
  },
  kyc: {
    BR: /^([0-9]){11}$/,
    CO: /^([0-9]){8,11}$/,
    AR: /^(20|23|24|27)[0-9]{8}[0-9]$/,
  },
}

export const rolesTypesRelatedPersons = [
  'attorney',
  'employee',
  'relatedPersons',
  'familyMember',
  'accountant',
  'lawyer',
  'others',
]

export const rolesTypesShareHolder = [
  'masterAttorney',
  'attorney',
  'employee',
  'relatedPersons',
  'familyMember',
  'accountant',
  'lawyer',
  'others',
]

export const iconByCountry = {
  brazil: 'br',
  colombia: 'co',
}

export const colorsByStatus = {
  IN_PROGRESS: 'var(--alert-dark)',
  DENIED: 'var(--error-dark)',
  APPROVED: 'var(--success-dark)',
  PROCESSED: 'var(--success-dark)',
}

export const getOptionLevels = (t) => [
  { value: 'LOW', label: t('common:LOW') },
  { value: 'MEDIUM', label: t('common:MEDIUM') },
  { value: 'HIGH', label: t('common:HIGH') },
  { value: 'VERY_HIGH', label: t('common:VERY_HIGH') },
]

export const getOptionsUnits = (t) => [
  { value: 'DAYS', label: t('common:days').toUpperCase() },
  { value: 'WEEKS', label: t('common:weeks').toUpperCase() },
  { value: 'MONTHS', label: t('common:months').toUpperCase() },
]

export const getOptionsStatus = (t) => [
  { value: 'APPROVED', label: t('common:APPROVED') },
  { value: 'DENIED', label: t('common:DENIED') },
  { value: 'IN_PROGRESS', label: t('common:IN_PROGRESS') },
  { value: 'NOT_STARTED', label: t('common:NOT_STARTED') },
  { value: 'PROCESSED', label: t('common:PROCESSED') },
]
